export default __webpack_public_path__ + "images/mailchimpIcon.79e825e39240a800be36e4515ef3a03c.png";